module.exports = __webpack_public_path__ + "img/code3.84257181.jpeg";